import * as React from 'react';

export function Dashboard(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      aria-label={props.label}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="navigation-icon-dashboard"
      {...props}
    >
      <g clipPath="url(#clip0_2088_10912)">
        <path
          d="M1 8.97817C1 8.36099 1.28495 7.77838 1.77212 7.39946L8.77212 1.95502C9.49434 1.39329 10.5057 1.39329 11.2279 1.95502L18.2279 7.39946C18.7151 7.77838 19 8.36099 19 8.97817V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V8.97817Z"
          fill="url(#paint0_linear_2088_10912)"
        />
        <g filter="url(#filter0_bi_2088_10912)">
          <path
            d="M14.1033 9.81698C14.4701 9.07374 15.5299 9.07374 15.8967 9.81699L17.4124 12.888C17.558 13.1831 17.8396 13.3877 18.1653 13.435L21.5543 13.9275C22.3746 14.0467 22.7021 15.0546 22.1086 15.6332L19.6562 18.0236C19.4205 18.2533 19.313 18.5843 19.3686 18.9087L19.9475 22.2841C20.0877 23.101 19.2302 23.724 18.4966 23.3383L15.4653 21.7446C15.174 21.5915 14.826 21.5915 14.5347 21.7446L11.5034 23.3383C10.7698 23.724 9.91235 23.101 10.0525 22.2841L10.6314 18.9087C10.687 18.5843 10.5795 18.2533 10.3438 18.0236L7.89144 15.6332C7.29792 15.0546 7.62543 14.0467 8.44565 13.9275L11.8347 13.435C12.1604 13.3877 12.442 13.1831 12.5876 12.888L14.1033 9.81698Z"
            fill="white"
            fillOpacity="0.5"
          />
          <path
            d="M15.4484 10.0383L16.964 13.1093C17.1825 13.552 17.6048 13.8588 18.0934 13.9298L21.4824 14.4223C21.8926 14.4819 22.0563 14.9859 21.7596 15.2751L19.3072 17.6656C18.9537 18.0102 18.7924 18.5067 18.8758 18.9933L19.4547 22.3686C19.5248 22.7771 19.0961 23.0885 18.7293 22.8957L15.698 21.3021C15.261 21.0723 14.739 21.0723 14.302 21.3021L11.2707 22.8957C10.9039 23.0885 10.4752 22.7771 10.5453 22.3686L11.1242 18.9933C11.2076 18.5067 11.0463 18.0102 10.6928 17.6656L8.24045 15.2751C7.94369 14.9859 8.10744 14.4819 8.51755 14.4223L11.9066 13.9298C12.3952 13.8588 12.8175 13.552 13.036 13.1093L14.5516 10.0383C14.735 9.66665 15.265 9.66664 15.4484 10.0383Z"
            stroke="white"
            strokeOpacity="0.2"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_bi_2088_10912"
          x="6.08838"
          y="7.75952"
          width="17.8232"
          height="17.1958"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.75" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2088_10912"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2088_10912"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2088_10912"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2088_10912"
          x1="10"
          y1="1"
          x2="10"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF57D0" stopOpacity="0.12" />
          <stop offset="1" stopColor="#FF8C8C" />
        </linearGradient>
        <clipPath id="clip0_2088_10912">
          <rect width="25" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
